import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { SearchRequestModel } from 'src/app/models/search-request-model';
import { SuggestRequestModel } from 'src/app/models/suggest-request-model';
import { ConstantsService } from 'src/app/services/constants.service';
import { FormsService } from 'src/app/services/forms.service';
import { PubSearchService } from 'src/app/services/pub-search.service';
import { QueryStateService } from 'src/app/services/query-state.service';

@Component({
  selector: 'app-search-simple-form',
  templateUrl: './search-simple-form.component.html',
  styleUrls: ['./search-simple-form.component.css']
})
export class SearchSimpleFormComponent implements OnInit {

  @Input() searchForm: FormGroup = new FormGroup({});

  searchRequest: SearchRequestModel;
  spaceOperator: string = ' ';
  notOperator: string = '-';
  showCombined = false;
  aSugs: string[] = [];
  loadSearchVisible: boolean = false;

  constructor(private formSvc: FormsService,
    private constants: ConstantsService, private router: Router,
    private queryStateSvc: QueryStateService, private searchSvc: PubSearchService) {
    this.searchRequest = { q: '', content: true};
  }

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    const keywordsControl = this.searchForm.get('keywords');
    if (keywordsControl) {
      keywordsControl.addValidators(this.formSvc.keywordLengthValidator);
      keywordsControl.updateValueAndValidity({ emitEvent: false });
    }
  }

  getSuggestions(event: any) {
    // don't call if the length is greater than 100
    if (event.query.length > 2 && event.query.length < 300) {
      let suggestQuery: SuggestRequestModel = { q: event.query, top: 25, suggester: this.constants.azSuggester };
      this.searchSvc.getSuggestions(suggestQuery).subscribe((data: string[]) => {
        // console.log("suggestions: " + JSON.stringify(data));
        this.aSugs = data;
      });
    }
  }

  kwSuggestionSelected(value: string) {
    // add quotes to selected items for auto-complete.
    this.searchForm.controls["keywords"].setValue(this.makeQuoted(value));
    // this.searchForm.controls["keywords"].setValue(value);
  }

  clearKeyword() {
    this.searchForm.controls["keywords"].setValue('');
  }

  makeQuoted(value: string): string {
    return "\"" + value + "\"";
  }

  clearSearch() {
    this.searchForm.controls["keywords"].setValue('');
  }

  advSearch() {
    this.router.navigate(['/adv-search']);
  }

  loadSearch() {
    this.loadSearchVisible = true;
  }

  executeLoadSearch(query: any) {
    this.loadSearchVisible = false;
    this.queryStateSvc.updateFormData(query);

    this.router.navigate([
      '/results/' + encodeURIComponent(JSON.stringify(this.queryStateSvc.getFormData())),
    ]);
  }

  closeLoadSearch() {
    this.loadSearchVisible = false;
  }

  submitForm() {
    if (this.searchForm.invalid) {
      this.searchForm.markAllAsTouched();
      return;
    }

    // Update the form values in the query state service which drives functions
    this.queryStateSvc.updateFormData(this.searchForm.value); // Will update/create the Search request in the Query Service.

    this.router.navigate([
      '/results/' + encodeURIComponent(JSON.stringify(this.queryStateSvc.getFormData())),
    ]);
  }

  /**
   * Check if keywords control has length validation error
   */
  get keywordLengthError(): boolean {
    return this.formSvc.controlHasKeywordLengthError(this.searchForm.get('keywords'));
  }
}
